import { render, staticRenderFns } from "./AdminClientsProductsManagement.module.vue?vue&type=template&id=40d48a3d&scoped=true&"
import script from "./AdminClientsProductsManagement.module.vue?vue&type=script&lang=js&"
export * from "./AdminClientsProductsManagement.module.vue?vue&type=script&lang=js&"
import style0 from "./AdminClientsProductsManagement.module.vue?vue&type=style&index=0&id=40d48a3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d48a3d",
  null
  
)

export default component.exports